import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Layout, Typography, Form, Input, Select, Button, Table, Card, Row, Col, Space, Tag, theme, Popconfirm, Breadcrumb, Tooltip, Modal, Descriptions, Spin } from 'antd';
import axios from 'axios';
import { APPBACKGROUND_COLOR, MAINAPIURL } from '../appsettings';
import Headerdiv from '../layout/header';
import Footerdiv from '../layout/footer';
import { AlertError, AlertSuccess } from '../usableclasses';
import { render } from '@testing-library/react';

const { Content } = Layout;

const WalletRequests = () => {
    const navigate = useNavigate();
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATEDBY = localStorage.getItem("USERID");


    const { token: { colorBgContainer, borderRadiusLG } } = theme.useToken();
    const [loading, setLoading] = useState(false);
    const [requests, setRequests] = useState([]);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [modalLoading, setModalLoading] = useState(false);

    useEffect(() => {
        fetchWalletRequests();
    }, []);

    const fetchWalletRequests = async () => {
        try {
            setLoading(true);
            const headers = { SystemAccessToken: TOKEN };
            const res = await axios.get(`${MAINAPIURL}/erp/mlmuser/walletrequestlist`, { headers });
            setRequests(res.data);
        } catch (error) {
            console.log(error);
            AlertError("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };
    const showReviewModal = (record) => {
        setSelectedRequest(record);
        setIsModalVisible(true);
    };

    const handleWalletApproval = async (status) => {
        if (!selectedRequest) return;

        try {
            setModalLoading(true);
            const headers = { SystemAccessToken: TOKEN };
            const payload = {
                requestId: selectedRequest.reqId,
                ...(status === 'APPROVED'
                    ? { approvedBy: UPDATEDBY }
                    : { rejectedBy: UPDATEDBY })
            };
            let res;
            if (status === 'APPROVED') {
                res = await axios.post(
                    `${ApiURL}/erp/mlmuser/walletrequestapprove`,
                    payload,

                    { headers }
                );
            } else if (status === 'REJECTED') {
                res = await axios.post(
                    `${ApiURL}/erp/mlmuser/walletrequestreject`,
                    payload,

                    { headers }
                );
            }

            if (res.data === true) {
                AlertSuccess(`Wallet request ${status.toLowerCase()} successfully`);
                setIsModalVisible(false);
                fetchWalletRequests(); // Refresh table
            }
        } catch (err) {
            console.error(err);
            AlertError('Failed to update request status');
        } finally {
            setModalLoading(false);
        }
    };

    const columns = [
        { title: 'Consultant ID', dataIndex: 'consultantId', key: 'consultantId' },
        { title: 'First Name', dataIndex: 'userFirstName', key: 'userFirstName' },
        { title: 'Second Name', dataIndex: 'userLastName', key: 'userLastName' },
        { title: 'Current Wallet Balance', dataIndex: 'currentWalletBalance', key: 'currentWalletBalance' },
        { title: 'Order No', dataIndex: 'orderNo', key: 'orderNo' },
        { title: 'Order Total', dataIndex: 'orderAmount', key: 'orderAmount' },
        {
            title: 'Request Type', dataIndex: 'requestType', key: 'requestType', render: (text) => (
                <Tag color={text === 'ADD' ? 'green' : 'red'}>{text}</Tag>
            )
        },
        { title: 'Request Amount', dataIndex: 'requestAmount', key: 'requestAmount' },
        { title: 'Reason', dataIndex: 'requestReason', key: 'requestReason' },
        { title: 'Request By', dataIndex: 'requestBy', key: 'requestBy' },
        { title: 'Request Date', dataIndex: 'requestDT', key: 'requestDT' },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Tooltip title="Review Wallet Request">
                    <Button 
                    type="primary" 
                    variant='outlined' 
                    size="small" 
                    color="yellow"
                    onClick={() => showReviewModal(record)}>
                        Review
                    </Button>
                </Tooltip>
            )
        }

    ];

    return (
        <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
            <Headerdiv />
            <Content style={{ padding: '10px' }}>
                <Breadcrumb style={{ margin: "16px 0" }}>
                    <Breadcrumb.Item><Link to={'/mlm/userlist'}>MLM User List</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>Wallet Requests</Breadcrumb.Item>
                </Breadcrumb>

                <Card title="Wallet Requests">
                    <Table
                        dataSource={requests}
                        columns={columns}
                        loading={loading}
                        scroll={{ x: 'max-content' }} // <-- Add this line
                        rowKey={(record) => record.id || record.consultantId}
                    />
                </Card>
                <Modal
                    open={isModalVisible}
                    title="Review Wallet Request"
                    onCancel={() => setIsModalVisible(false)}
                    confirmLoading={modalLoading}
                    footer={[
                        <Button key="reject" disabled={modalLoading} danger onClick={() => handleWalletApproval('REJECTED')}>
                            {modalLoading ? 'Rejecting...' : 'Reject'}
                        </Button>,
                        <Button key="approve" disabled={modalLoading} type="primary" onClick={() => handleWalletApproval('APPROVED')}>
                            {modalLoading ? 'Approving...' : 'Approve'}
                        </Button>
                    ]}
                >
                    {selectedRequest ? (
                        <Descriptions bordered column={1} size="small">
                            <Descriptions.Item label="Consultant ID">{selectedRequest.consultantId}</Descriptions.Item>
                            <Descriptions.Item label="First Name">{selectedRequest.userFirstName}</Descriptions.Item>
                            <Descriptions.Item label="Second Name">{selectedRequest.userLastName}</Descriptions.Item>
                            <Descriptions.Item label="Current Wallet Balance">{selectedRequest.currentWalletBalance}</Descriptions.Item>
                            <Descriptions.Item label="Order No">{selectedRequest.orderNo}</Descriptions.Item>
                            <Descriptions.Item label="Order Total">{selectedRequest.orderAmount}</Descriptions.Item>
                            <Descriptions.Item label="Request Type"><Tag color={selectedRequest.requestType === 'ADD' ? 'green' : 'red'}>{selectedRequest.requestType}</Tag></Descriptions.Item>
                            <Descriptions.Item label="Request Amount">{selectedRequest.requestAmount}</Descriptions.Item>
                            <Descriptions.Item label="Reason">{selectedRequest.requestReason}</Descriptions.Item>
                            <Descriptions.Item label="Request Date">{selectedRequest.requestDT}</Descriptions.Item>
                        </Descriptions>
                    ) : (
                        <Spin />
                    )}
                </Modal>

            </Content>
            <Footerdiv />
        </Layout>
    );
};

export default WalletRequests;
